<template>
	<div class="product-page">
		<!-- 查询区域 -->
		<div class="search-container" :class="{ 'search-container-fixed': isSearchFixed }">
			<div class="search-wrapper">
				<div class="custom-search-input">
					<el-input type="text" :placeholder="$t('searchStorePlaceholder')" v-model="searchKeyword"
						class="search-input" @keyup.enter.native="search" />
					<button class="search-button" @click="search">{{ $t('search') }}</button>
				</div>
			</div>
		</div>

		<!-- 商家组件 -->
		<div :style="{marginTop:isSearchFixed?'90px':0}">
			<MerchantList ref="merchantList" :search-keyword="searchKeyword" :scroll-top="isSearchFixed ? 110 : 0" />
		</div>

		<RightFixedPanel @openEnquiry="enquiryDialogVisible = true" @openComplaint="complaintDialogVisible = true" />

		<EnquiryDialog :visible.sync="enquiryDialogVisible" />

		<ComplaintDialog :visible.sync="complaintDialogVisible" />
	</div>
</template>

<script>
	import MerchantList from '@/components/MerchantList.vue';
	import RightFixedPanel from '@/components/RightFixedPanel.vue';
	import EnquiryDialog from '@/components/EnquiryDialog.vue';
	import ComplaintDialog from '@/components/ComplaintDialog.vue'
	export default {
		name: 'Merchant',
		components: {
			MerchantList,
			RightFixedPanel,
			EnquiryDialog,
			ComplaintDialog
		},
		data() {
			return {
				searchKeyword: '',
				isSearchFixed: false,
				enquiryDialogVisible: false,
				complaintDialogVisible: false,
			}
		},
		mounted() {
			// 添加滚动事件监听器
			window.addEventListener('scroll', this.handleScroll)
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll)
			})
			this.loadMerchant();
		},
		methods: {
			loadMerchant() {
				this.$nextTick(() => {
					//加载商家列表
					if (this.$refs.merchantList && typeof this.$refs.merchantList.init === 'function') {
						this.$refs.merchantList.init();
					}
				});
			},
			search() {
				this.loadMerchant();
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				// 简单实现搜索框固定效果
				this.isSearchFixed = scrollTop > 100;
			}
		}
	}
</script>

<style scoped>
	.product-page {
		padding: 0;
	}

	/* Search bar styles */
	.search-container {
		display: flex;
		justify-content: center;
		z-index: 10;
	}

	.search-container.search-container-fixed {
		position: fixed !important;
		top: 0px !important;
		left: 0 !important;
		right: 0 !important;
		bottom: auto !important;
		z-index: 1000 !important;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
	}

	.search-container.search-container-fixed .search-wrapper {
		background-color: white !important;
		padding: 10px;
	}

	.search-container.search-container-fixed .custom-search-input {
		border-color: #F59A23;
		background-color: rgba(0, 0, 0, 0.05);
	}

	.search-container.search-container-fixed .search-button {
		height: 35px;
		width: 100px;
		font-size: 14px;
	}

	.search-container.search-container-fixed :deep .el-input__inner {
		color: #333;
		height: 35px;
	}

	.search-wrapper {
		background-color: #016AF8;
		padding: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		gap: 10px;
	}

	.custom-search-input {
		display: flex;
		align-items: center;
		border-radius: 10px;
		width: 70%;
		overflow: hidden;
		background-color: rgba(0, 0, 0, 0.35);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		border: 2px solid #F59A23;
	}

	.search-button {
		background-color: #F59A23;
		color: white;
		border: none;
		height: 60px;
		width: 160px;
		cursor: pointer;
		font-size: 17px;
		transition: background-color 0.3s;
	}

	:deep .el-input__inner {
		background-color: transparent !important;
		border: 0 solid #DCDFE6;
		font-size: 16px;
		color: #fff;
	}

	.search-button:hover {
		background-color: #F59A23;
	}

	/* Ensure proper spacing between elements */
	.product-page {
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	}

	/* Make buttons match Element UI styles */
	:deep .el-button--primary.is-plain {
		border-color: #016AF8;
		color: #016AF8;
	}

	:deep .el-button--primary.is-plain:hover {
		background-color: #016AF8;
		color: #fff;
	}
</style>